import React from 'react';
import moment from 'moment';
import * as CONFIG from 'constants/config';
import { connect } from 'react-redux';
import { ShowIf } from 'components/utils';
import { DatePicker } from 'components/tt-forms/common';
import { DropDownChonStateXuLyDon, DropDownChonPhongBanThuocCoQuan, DropDownChonCanBoXuLy } from 'components/tt-forms';
import { LetterProcessingWorkFlow, DuLieuHeThong} from 'api';
import { processType } from 'constants/process-type';
import { validatable } from 'components/utils';
import { msg } from "constants/message";

const process = [processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong, processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien];

class LanhDaoGiaoViecPU extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      form_GiaoViecTruongPhong: false,
      form_GiaoViecCanBo: false,

      donId: this.props.donId,

      numberState: 0,
      onlyState: '',

      nextState: '',

      hideDropdown: false,

      thoiHanXuLy: new Date(),
      noiDung: '',
      phongBanChiDinh: '',
      truongPhongChiDinh: '',
      canBoChiDinh: '',

    }
  }

  componentWillMount() {
    this.checkState();
  }

  checkState() {

    let numberState = 0;
    let onlyState = '';

    process.map((item, i) => {

      if (this.props.getState(this.props.listNextStates, item)) {

        onlyState = item;
        numberState++;

        switch (item) {

          case processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_GiaoViecTruongPhong: true
            });
            break;

          case processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien:
            this.setState({
              onlyState: onlyState,
              numberState: numberState,
              form_GiaoViecCanBo: true
            });
            break;
        }
      }
    });
  }

  componentDidMount() {

    this.onlyOneState();
    if (this.state.donId == 0) {
      this.getThoiHanXuLyMacDinh();
    } else {
      this.getThongTinXuLy(this.state.donId);
    }
  }

  onlyOneState() {

    if (this.state.numberState == 1) {
      let newState = {
        ...this.state,
        nextState: this.state.onlyState,
        hideDropdown: true,
      }

      this.setState({
        ...newState
      }, this.trigger(newState, true));
    }
  }

  getThoiHanXuLyMacDinh() {
    DuLieuHeThong.actions.getThoiHanXuLyMacDinh.request().then(res => {
      let thoiHanXuLyMacDinh = moment(res.data).format('DD/MM/YYYY');
      this.setState({
        thoiHanXuLy: thoiHanXuLyMacDinh
      })
    })
  }

  getThongTinXuLy(donId) {
    LetterProcessingWorkFlow.actions.getThongTinXuLy.request({ id: donId }).then(res => {
      if (res.data) {
        let info = res.data.thongTinXuLyInfo;

        let newState = { ...this.state };

        if (info.thoiHanXuLy != null)
          newState = {
            ...this.state,
            thoiHanXuLy: moment(info.thoiHanXuLy),
          }

        if (info.nextState != null) {

          newState = {
            ...this.state,
            nextState: info.nextState.type,
            phongBanChiDinh: info.phongBanXuLyChiDinh.id,
            noiDung: info.yKienXuLy,
            thoiHanXuLy: moment(info.thoiHanXuLy),
            truongPhongChiDinh: info.nextState && info.nextState.type == 'LANH_DAO_GIAO_VIEC_TRUONG_PHONG' ? info.canBoXuLyChiDinh.id : '',
            canBoChiDinh: info.nextState && info.nextState.type == 'LANH_DAO_GIAO_VIEC_CAN_BO' ? info.canBoXuLyChiDinh.id : ''
          }
        }

        this.setState({
          ...newState
        });

        this.trigger(newState, true);
      }
    })
  }

  handleChange(name, e) {

    let newState = {
      ...this.state,
      [name]: e.target.value
    }

    if (name == 'nextState') {



      if (this.state.donId == 0) {
        newState = {
          ...newState,
          phongBanChiDinh: '',
          truongPhongChiDinh: '',
          canBoChiDinh: ''
        }
      }

    } else if (name == 'phongBanChiDinh') {

      newState = {
        ...newState,
        truongPhongChiDinh: '',
        canBoChiDinh: ''
      }
    }

    this.setState({
      ...newState
    }, this.trigger(newState, false));
  }

  handleChangeDate(name, e) {

    if (typeof e.format == 'function') {
      let newState = {
        ...this.state,
        [name]: e.format(CONFIG.DateFormat)
      }

      this.setState({
        ...newState
      }, this.trigger(newState));
    } else {

      let newState = {
        ...this.state,
        [name]: e
      }

      this.setState({
        ...newState
      }, this.trigger(newState));
    }
  }

  trigger(newState, isInit) {

    if (newState.nextState) {

      let stateId = this.props.getState(this.props.listNextStates, newState.nextState);

      let params = {
        thoiHanXuLy: moment(newState.thoiHanXuLy, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
        noiDungYeuCauXuLy: newState.noiDung,
        nextState: {
          id: Number(stateId),
          type: newState.nextState
        }
      }

      if (newState.phongBanChiDinh) {
        params.phongBanXuLyChiDinh = {
          id: Number(newState.phongBanChiDinh)
        }
      }

      // Them param theo dieu kien huong xu ly
      if (newState.form_GiaoViecTruongPhong && newState.nextState == processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong) {

        params.notice = msg.xldLanhDaoGiaoViec;

        if (newState.truongPhongChiDinh) {
          params.canBoXuLyChiDinh = {
            id: Number(newState.truongPhongChiDinh)
          }
        }
      } else if (newState.form_GiaoViecCanBo && newState.nextState == processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien) {

        params.notice = msg.xldLanhDaoGiaoViec;

        if (newState.canBoChiDinh) {
          params.canBoXuLyChiDinh = {
            id: Number(newState.canBoChiDinh)
          }
        }
      }

      this.props.onChange(params, isInit);
    } else {

      let params = {
        noiDungYeuCauXuLy: newState.noiDung,
      }

      this.props.onChange(params, isInit);
    }
  }

  render() {
    return (
      <div className="body-dialog-gh">
        <span className='col-100 text-13 pt25 pl20 pb10'>{this.props.content}</span>
        <div className="row pl30 pr30 pt20">

          <ShowIf condition={!this.state.hideDropdown}>
            <DropDownChonStateXuLyDon require
              className="col-50"
              value={this.state.nextState}
              label="Giao xử lý"
              onChange={this.handleChange.bind(this, 'nextState')}
              data={this.props.listNextStates}
              bindValidator={this}
              name="dropdownHuongXuLy" />
          </ShowIf>

          <DatePicker require
            className="col-50"
            bindValidator={this}
            channel="formTaoDon"
            isValid={this.props.validate}
            label='Hạn xử lý'
            value={this.state.thoiHanXuLy}
            startDate={moment(new Date()).subtract(1, "days")}
            onChange={this.handleChangeDate.bind(this, 'thoiHanXuLy')} />
        </div>
        <div className="row pl30 pr30">
          <ShowIf condition={(this.state.form_GiaoViecTruongPhong && this.state.nextState == processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong) ||
            (this.state.form_GiaoViecCanBo && this.state.nextState == processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien)}>
            <DropDownChonPhongBanThuocCoQuan require
              className="col-50"
              bindValidator={this}
              selectedValue={this.state.phongBanChiDinh}
              isValid={this.props.validate}
              onChange={this.handleChange.bind(this, 'phongBanChiDinh')}
              name="dropdownChonPhongBanThuocCoQuan" />
          </ShowIf>

          <ShowIf condition={this.state.form_GiaoViecCanBo
            && this.state.nextState == processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien
            && this.state.phongBanChiDinh != ''}>
            <DropDownChonCanBoXuLy require
              className="col-50"
              bindValidator={this}
              vaiTro="CHUYEN_VIEN"
              selectedValue={this.state.canBoChiDinh}
              phongBanId={this.state.phongBanChiDinh}
              onChange={this.handleChange.bind(this, 'canBoChiDinh')}
              name="dropdownChonCanBoXuLyChuyenVien" />
          </ShowIf>
        </div>
      </div>
    );
  }
}

LanhDaoGiaoViecPU.defaultProps = {
  listNextStates: [],
  validate: false,
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  getState: function () {
    console.log('Need to assign getState method');
  }
}

function bindStateToProps(state) {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
  }
}

export default connect(bindStateToProps)(validatable(LanhDaoGiaoViecPU));



// WEBPACK FOOTER //
// ./src/components/modules/dialog/thu-hoi-form/LanhDaoGiaoViecPU.jsx